// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: 5JnDz-tqZ8

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicGridModeIcon.module.css"; // plasmic-import: 5JnDz-tqZ8/css

createPlasmicElementProxy;

export type PlasmicGridModeIcon__VariantMembers = {
  selected: "selected";
  color: "blue" | "red";
};
export type PlasmicGridModeIcon__VariantsArgs = {
  selected?: SingleBooleanChoiceArg<"selected">;
  color?: SingleChoiceArg<"blue" | "red">;
};
type VariantPropType = keyof PlasmicGridModeIcon__VariantsArgs;
export const PlasmicGridModeIcon__VariantProps = new Array<VariantPropType>(
  "selected",
  "color"
);

export type PlasmicGridModeIcon__ArgsType = {};
type ArgPropType = keyof PlasmicGridModeIcon__ArgsType;
export const PlasmicGridModeIcon__ArgProps = new Array<ArgPropType>();

export type PlasmicGridModeIcon__OverridesType = {
  root?: p.Flex<"button">;
  freeBox?: p.Flex<"div">;
};

export interface DefaultGridModeIconProps {
  selected?: SingleBooleanChoiceArg<"selected">;
  color?: SingleChoiceArg<"blue" | "red">;
  className?: string;
}

const $$ = {};

function PlasmicGridModeIcon__RenderFunc(props: {
  variants: PlasmicGridModeIcon__VariantsArgs;
  args: PlasmicGridModeIcon__ArgsType;
  overrides: PlasmicGridModeIcon__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "selected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.selected
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.color
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <p.Stack
      as={"button"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootcolor_blue]: hasVariant($state, "color", "blue"),
          [sty.rootselected]: hasVariant($state, "selected", "selected"),
          [sty.rootselected_color_red]:
            hasVariant($state, "selected", "selected") &&
            hasVariant($state, "color", "red")
        }
      )}
    >
      <p.PlasmicImg
        alt={""}
        className={classNames(sty.img___1LFn, {
          [sty.imgcolor_blue___1LFnprC2T]: hasVariant($state, "color", "blue"),
          [sty.imgcolor_red___1LFnyrkS1]: hasVariant($state, "color", "red"),
          [sty.imgselected___1LFn6AKjm]: hasVariant(
            $state,
            "selected",
            "selected"
          )
        })}
        displayHeight={
          hasVariant($state, "selected", "selected") ? "30px" : "30px"
        }
        displayMaxHeight={"none"}
        displayMaxWidth={"none"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={
          hasVariant($state, "selected", "selected") ? "30px" : "30px"
        }
        loader={"plasmic"}
        loading={"lazy"}
        src={{
          src: "https://site-assets.plasmic.app/ca7893244df680958404f0998c1ca21b.svg",
          fullWidth: 134,
          fullHeight: 150,
          aspectRatio: 0.896552
        }}
      />

      <p.PlasmicImg
        alt={""}
        className={classNames(sty.img__nBt0Z, {
          [sty.imgcolor_red__nBt0ZyrkS1]: hasVariant($state, "color", "red"),
          [sty.imgselected_color_red__nBt0Z6AKjmYrkS1]:
            hasVariant($state, "selected", "selected") &&
            hasVariant($state, "color", "red")
        })}
        displayHeight={"auto"}
        displayMaxHeight={"none"}
        displayMaxWidth={"none"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={"30px"}
        loader={"plasmic"}
        loading={"lazy"}
        src={{
          src: "https://site-assets.plasmic.app/329e121ac95ff3410b8e31cd2c905922.svg",
          fullWidth: 139,
          fullHeight: 150,
          aspectRatio: 0.928571
        }}
      />

      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxselected]: hasVariant($state, "selected", "selected")
        })}
      />
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicGridModeIcon__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicGridModeIcon__VariantsArgs;
    args?: PlasmicGridModeIcon__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicGridModeIcon__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicGridModeIcon__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicGridModeIcon__ArgProps,
          internalVariantPropNames: PlasmicGridModeIcon__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicGridModeIcon__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicGridModeIcon";
  } else {
    func.displayName = `PlasmicGridModeIcon.${nodeName}`;
  }
  return func;
}

export const PlasmicGridModeIcon = Object.assign(
  // Top-level PlasmicGridModeIcon renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicGridModeIcon
    internalVariantProps: PlasmicGridModeIcon__VariantProps,
    internalArgProps: PlasmicGridModeIcon__ArgProps
  }
);

export default PlasmicGridModeIcon;
/* prettier-ignore-end */
